var B = function B(v2) {};

B._r = [0, ["IT"]];
B.displayName = "B";

function fn(v) {}

fn._r = [2, [null]];
fn.displayName = "fn";

var MyClass = function MyClass(deps) {};

MyClass._r = [0, [{
  b: null
}]];
MyClass.displayName = "MyClass";